<l-page [tabHeaders]="['Widget & Layout Library', 'Flow Graph', 'Vis Graph']" [tabHeadersIcons]="['fas fa-check']">
  <l-lcr-page-layout tab0>
    <app-field-wrapper left labelsWidth="150px">
      <w-text-field [(value)]="text" label="Text:"></w-text-field>
      <w-textarea-field [(value)]="text" label="Textarea:" [rowSpan]="3" [hideLabel]="true"></w-textarea-field>
      <w-number-field [(value)]="number" label="Number:"></w-number-field>
      <w-date-field [(value)]="date" label="Date:"></w-date-field>
      <w-multi-column-field [widthSplits]="['240px', '240px']" [isLabel]="[false, false]">
        <w-number-field c0 [(value)]="number" label="Composed:"></w-number-field>
        <w-text-field c1 [(value)]="text" label="Other Composed:"></w-text-field>
      </w-multi-column-field>
      <w-time-field [(value)]="date" label="Hour:"></w-time-field>
      <w-customer-field [(customer)]="customer" label="Customer:" (valueChange)="cons($event)"></w-customer-field>
      <w-worker-field [(user)]="worker" label="Worker:" (valueChange)="cons($event)"></w-worker-field>
      <w-boolean-field [(value)]="bool" label="Boolean:" (valueChange)="cons($event)"></w-boolean-field>
      <w-dropdown-field [value]="selectables[0]" label="Dropdown:" (valueChange)="dropdownSelect($event)"
                        [options]="selectables"></w-dropdown-field>
      <!--      <w-single-select label="Single Select:" [value]="singleSelectables[0]" (valueChange)="singleSelect($event)" [options]="singleSelectables"></w-single-select>-->
      <!--      <w-multi-select label="Multi Select:" [value]="[multiSelectables[0], multiSelectables[2]]" (valueChange)="multiSelect($event)" [options]="multiSelectables"></w-multi-select>-->
      <!--      <w-flag-single-select label="Flag Single:" [(value)]="flagValue" (valueChange)="cons($event)"></w-flag-single-select>-->
      <!--      <w-flag-multi-select label="Flag Multi:" [(value)]="flagValues" (valueChange)="cons($event)"></w-flag-multi-select>-->

      <w-date-field-interval label="date picker with interval:"></w-date-field-interval>

      <button pButton pRipple label="Display" (click)="notify1()"> Show notification </button>
<!--      <button pButton pRipple label="Display" (click)="popAudits()"> Show audits </button>-->
      <button pButton pRipple label="Display" (click)="generateEml()"> Create eml </button>

<!--      <app-audit-modal [auditPopupOpen]="showAudits" [auditList]="snippetAuditList" (selectedAudit)="getSnippetVersion($event)" (revertRequest)="revertSnippet()">-->
<!--        <snippets-display display [snippetDto]="snippetDto"></snippets-display>-->
<!--      </app-audit-modal>-->

<!--      <p-toast key="block1" [style]="{width: '30rem'}" [preventOpenDuplicates]="true" [baseZIndex]="5000" styleClass="notification-content">-->
<!--        <ng-template let-message pTemplate="message">-->
<!--          <div class="notification-content">-->
<!--            <div class="bell">-->
<!--              <i class="fas fa-bell"></i>-->
<!--            </div>-->
<!--            <div class="notification-title">-->
<!--              <div class="notification-icon">-->
<!--                    <span class="icon">-->
<!--                        <i class="fas fa-calendar"></i>-->
<!--                    </span>-->
<!--                <h2>&nbsp;&nbsp;{{message.summary}}</h2>-->
<!--              </div>-->
<!--              <h3>You have been summoned to the elders committee of the Shire. The meeting starts in <b class="time-left">{{message.detail}} minutes.</b> </h3>-->
<!--            </div>-->
<!--            <div class="buttons">-->
<!--              <button pButton pRipple label="Update" class="p-button-text font-medium" (click)="clear('block1')">Dismiss</button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-template>-->
<!--      </p-toast>-->
    </app-field-wrapper>

    <!--    <app-communication-builder center [comm]="comm" [newLead]="newLead" [lead]="lead"></app-communication-builder>-->
  </l-lcr-page-layout>
  <l-full-page-layout tab1>
    <app-flowgraph-page></app-flowgraph-page>
  </l-full-page-layout>
  <l-full-page-layout tab2>
    <app-vis-graph-page></app-vis-graph-page>
  </l-full-page-layout>
</l-page>


